import { CANAL, APP_VERSION } from "../helpers/constants";
import { axiosInstance } from "../helpers/axios";

const userAgent = window.navigator.userAgent;

const getRFC = (
  nombres,
  apellidoPaterno,
  apellidoMaterno,
  usuario,
  fechaNacimiento,
  securitykey,
) => {
  return axiosInstance
    .post("getRFC/", {
      userAgent: userAgent,
      carrierCelular: userAgent,
      version: APP_VERSION,
      canal: CANAL,
      names: nombres,
      firstName: apellidoPaterno,
      lastName: apellidoMaterno,
      usuario: usuario,
      birthdate: fechaNacimiento,
      llaveSeguridad: securitykey,
    })
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      console.log("error");
      console.log(err.message);
    });
};

export default { getRFC };
